export enum SegmentoSimulacao {
  BASICO = "BASICO",
  INTERMEDIARIO = "INTERMEDIARIO",
  AVANCADO = "SUPERIOR",
}
